import * as React from "react";
import type { SVGProps } from "react";
const SvgMoneyWavy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={props.color}
      d="M15.265 3.75a.5.5 0 0 0-.484-.025c-2.684 1.312-4.6.697-6.625.048-2.125-.68-4.328-1.383-7.372.103a.5.5 0 0 0-.284.451v7.496a.5.5 0 0 0 .72.45c2.682-1.313 4.599-.698 6.627-.05 1.203.385 2.428.777 3.813.777 1.068 0 2.233-.233 3.557-.88a.5.5 0 0 0 .28-.448V4.176a.5.5 0 0 0-.232-.426m-.765 7.604c-2.537 1.136-4.39.543-6.347-.082-1.203-.385-2.428-.777-3.813-.777a7.6 7.6 0 0 0-2.837.563V4.645c2.537-1.135 4.39-.543 6.347.083 1.957.625 3.971 1.272 6.65.215zM8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2M3.5 6v3a.5.5 0 0 1-1 0V6a.5.5 0 1 1 1 0m9 4V7a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0"
    />
  </svg>
);
export default SvgMoneyWavy;
